export const setActiveCheckbox = (arrayWithCurrentOptions, option) => {
    if (arrayWithCurrentOptions.find((element) => element === option)) {
        return true;
    }

    return false;
};
